import { AdsStages } from '../../models/Ads';
import { createSlice } from '../wrappers';

interface IAdsState {
	activeAdsState: AdsStages;
}

const initialState: IAdsState = {
	activeAdsState: AdsStages.LIVE,
};

const adsSlice = createSlice({
	name: 'ads',
	initialState,
	reducers: {
		setActiveAdsState: (state, action) => {
			state.activeAdsState = action.payload;
		},
	},
});

export const { setActiveAdsState } = adsSlice.actions;

export default adsSlice.reducer;
